module.exports = __webpack_public_path__ + "static/img/e4.af8bac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/e4.png
// module id = Jpnj
// module chunks = 0